import { Location } from "./location";

export class Facility
{
    constructor
    (
        public name: string,
        public npiName: string,
        public ein: string,
        public npi: string
    )
    {

    }

    aliases: string[] = [];
}

export class FacilityLocation
{
    name: string = ''

    constructor
    (
        public facility: Facility,
        public location: Location
    )
    { 
        if (facility)
        {
            this.name = this.facility.name + " (" + this.facility.ein + ") ";
        }
    }

    get displayText():string
    {
        return this.name;
    }

    generateProviderLocationIdentifier() : ProviderLocationIdentifier
    {
        return new ProviderLocationIdentifier(this.facility.ein, this.facility.npi,this.location.id);
    }

}

export class ProviderLocationIdentifier
{
    constructor(public ein: string, public npi: string, public locationId : number) {}
}